import * as turf from '@turf/turf';
import * as Cesium from 'cesium';
import { GenericAttribute } from './generic-attribute.service';
import { ReportMapEntity } from './report-map-entity.service';
import { CameraService } from './camera.service';
import { CoresService } from './cores.service';
import { DefaultEditCommand, DefaultDeleteCommand, DefaultShowHideCommand, DefaultGoToTimeCommand, DefaultTrackingCommand } from '../models/command';
import { CoreService } from './core.service';
import { WindowService } from './window.service';
import { DataContextService } from './data-context.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TimelineService } from './timeline.service';

export class SafeZoneMapEntity extends ReportMapEntity {
  safezoneEntityIds: string[] = [];
  safezone: any;
  override description: string = '';
  arcAngelId: string = '';
  eventId: string = '';
  isActive: boolean = false;
  lastUpdate: any = undefined;
  perimeterSafezoneId?: any;
  organizationId?: any;
   LIVE_MODE = 'Live Mode';

  constructor(
    safezone: any,
    eventId: string,
    playback: boolean,
    cameraService: CameraService,
    private Core: CoresService,
    coreService: CoreService,
    windowService: WindowService,
    dataContext: DataContextService,
    modalService: NgbModal,
    timelineService: TimelineService,
    private GenericAttributeClass?: GenericAttribute,
   
  ) {
    // Determine lat/lon
    let lat: number | undefined;
    let lon: number | undefined;
    if (safezone.geometry && safezone.geometry.type === 'Point') {
      lat = safezone.geometry.coordinates[1];
      lon = safezone.geometry.coordinates[0];
    } else if (safezone.geometry && safezone.geometry.type === 'Polygon') {
      const polygon = { type: 'Feature', geometry: safezone.geometry, properties: {} };
      const centroid = turf.centroid(polygon as any);
      if (centroid) {
        lat = centroid.geometry.coordinates[1];
        lon = centroid.geometry.coordinates[0];
      }
    }
    if ((lat === undefined || lat === null) || (lon === undefined || lon === null)) {
      super('', '', '0', '', 0, 0, 0, new Date(), '', cameraService,coreService,windowService,dataContext,modalService,timelineService);
      return;
    }

    const id = safezone.id;
    const name = safezone.label;
    const date = safezone.date;
    const description = safezone.description;
    const isActive = safezone.isActive;

    const entityId = playback ? 'arc-angel-playback-' + id : 'arc-angel-' + id;
    super(
      entityId,
      name,
      'ArcAngel//Safe Zones',
      'assets/img/arcangel/safezone.png',
      lat,
      lon,
      0,
      date,
      '',
      cameraService,
      coreService,
      windowService,
      dataContext,
      modalService,
      timelineService
    );

    this.safezone = safezone;
    this.perimeterSafezoneId =
      safezone?.perimeterSafezoneId ??
      safezone?.perimterSafezoneId ??
      (safezone?.perimterId || safezone?.perimeterId ? safezone?.id : undefined);
    this.setTimestamp(date);
    this.description = description;
    this.setShowInLayersUI(false);
    this.arcAngelId = id;
    this.eventId = eventId;
    this.organizationId = safezone?.organizationId ?? safezone?.organization_id;
    this.isActive = isActive;
    if (isActive === false || isActive === 'false') {
      if (this.cesiumEntity) {
        this.cesiumEntity.show = false;
      }
    }
    this.lastUpdate = undefined;
    this.addAttribute(new GenericAttribute('Activate/Deactivate', this.getId(), false, false, 0, 'safezoneattributevisualizer'));

    this.removeDeleteCommand?.();
    this.removeShowHideCommand?.();
    this.removeTimelineCommand?.();
    this.removeTrackCommand?.();

    if (this.commands && DefaultEditCommand) {
      for (let i = 0; i < this.commands.length; i++) {
        const command = this.commands[i];
        if (command instanceof DefaultEditCommand) {
          command.modesVisible = [this.LIVE_MODE || ''];
          break;
        }
      }
    }
  }

  getEventId(): string {
    return this.eventId;
  }
  override setDescription(text: string): void {
    this.description = text;
  }
  getDescription(): string {
    return this.description;
  }
  setLastUpdate(lastUpdate: any): void {
    this.lastUpdate = lastUpdate;
  }
  getLastUpdate(): any {
    return this.lastUpdate;
  }
  getArcAngelId(): string {
    return this.arcAngelId;
  }
  getIsActive(): boolean {
    return this.isActive;
  }
  getPerimeterSafezoneId(): any {
    return this.perimeterSafezoneId ?? this.safezone?.perimeterSafezoneId;
  }
  setPerimeterSafezoneId(id: any): void {
    this.perimeterSafezoneId = id;
    if (this.safezone) {
      this.safezone.perimeterSafezoneId = id;
    }
  }
  isPerimeterSafezone(): boolean {
    return !!(
      this.perimeterSafezoneId ||
      this.safezone?.perimeterSafezoneId ||
      this.safezone?.perimterId ||
      this.safezone?.perimeterId ||
      this.safezone?.isPerimeterSafezone ||
      this.safezone?.isPerimeter ||
      this.safezone?.perimeterSafezone ||
      this.safezone?.type === 'PERIMETER_SAFEZONE' ||
      this.safezone?.type === 'PerimeterSafezone'
    );
  }
  setIsActive(isActive: boolean): void {
    this.isActive = isActive;
    if (this.cesiumEntity) {
      this.cesiumEntity.show = !!isActive;
    }
    if (this.Core && this.Core.getViewer()) {
      const viewer = this.Core.getViewer();
      const entity = viewer?.entities?.getById(this.getId());
      if (entity) {
        entity.show = !!isActive;
        if (entity.billboard) {
          entity.billboard.show = !!isActive;
        }
      }
    }
    if (!isActive) {
      this.removePolygon();
    }
  }

  override onDelete(): void {
  }

  override showEditWindow(): any {
    if (this.windowService) {
      return "";
      // return this.windowService.openModalWindow(
      //   this,
      //   'IncidentSafeZoneEditDialogController',
      //   'components/arcangel/views/safezone-edit-dialog.html'
      // );
    }
    return Promise.resolve();
  }

  drawPolygon(): void {
    this.removePolygon();
    if (this.safezone.geometry && (this.safezone.geometry.type === 'Polygon' || this.safezone.geometry.type === 'MultiPolygon') && this.Core && this.Core.getViewer()) {
      let polygons: any[] = [];

      if (this.safezone.geometry.type === 'Polygon') {
        polygons = [this.safezone.geometry.coordinates];
      } else if (this.safezone.geometry.type === 'MultiPolygon') {
        polygons = this.safezone.geometry.coordinates;
      }

      polygons.forEach((polygonCoords, index) => {
        const outerRing = polygonCoords[0];
        const positions = outerRing.map((coord: [number, number]) =>
          Cesium.Cartesian3.fromDegrees(coord[0], coord[1])
        );

        const entityId = `safezone-polygon-${this.arcAngelId}-${index}`;
        const existingEntity = this.Core.getViewer().entities.getById(entityId);
        if (existingEntity) {
          this.Core.getViewer().entities.remove(existingEntity);
        }

        const entity = new Cesium.Entity({
          id: entityId,
          name: `${this.safezone.label || 'Unnamed Polygon'} - ${index}`,
          polygon: {
            hierarchy: new Cesium.PolygonHierarchy(positions),
            material: Cesium.Color.fromAlpha(Cesium.Color.fromCssColorString('#00aa00'), 0.5),
            outline: true,
            outlineColor: Cesium.Color.fromAlpha(Cesium.Color.fromCssColorString('#aaaa00'), 1.0),
            height: 0,
            extrudedHeight: 0
          }
        });

        this.Core.getViewer().entities.add(entity);
        this.safezoneEntityIds.push(entityId);
      });
    }
  }

  removePolygon(): void {
    if (this.Core && this.safezoneEntityIds.length > 0) {
      this.safezoneEntityIds.forEach(entityId => {
        const entity = this.Core.getViewer().entities.getById(entityId);
        if (entity) {
          this.Core.getViewer().entities.remove(entity);
        }
      });
      this.Core.getViewer().scene.requestRender();
    }
    this.safezoneEntityIds = [];
  }
    setLatitude(latitude: number): void {
    this.setCenterLatitude(latitude);
  }

  setLongitude(longitude: number): void {
    this.setCenterLongitude(longitude);
  }

}